import {
    clearNotify,
    notify,
    sendRequest
} from "../api";
import {
    RESET_FORM,
    RESET_STATE,
    SET_FORM,
    SET_KEY_LIST,
    SET_LIST,
    UPDATE_FORM
} from "../constant-types";

const getDefaultState = () => {
    return {
        general_setting_loaded: false,
        form: null,
        key_list: null,
    }
}
export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [SET_KEY_LIST](state, payload) {
            state.key_list = payload;
            state.general_setting_loaded = true;
            // should fire events to tell related component
            app.$events.fire('general-setting-loaded');
        },
        [SET_FORM](state, payload) {
            state.form = _.groupBy(payload, 'group');
        },
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [RESET_FORM](state) {
            state.form = null
        },
        [UPDATE_FORM](state, payload) {
            state.form[payload.group][payload.index].value = payload.value;
        }
    },
    // can async
    actions: {
        loadKeyList({
            commit
        }) {
            return sendRequest('general-setting/key-list', {}, 'get',
                (response) => {
                    commit(SET_KEY_LIST, response)
                },
                () => {},
                () => {})
        },
        loadList({
            commit
        }) {
            notify('default', 'memuat...', null)
            return sendRequest('general-setting', {}, 'get',
                (response) => {
                    clearNotify();
                    commit(SET_FORM, response);
                },
                () => {},
                () => {})
        },
        requestSaveList({
            state, commit
        }) {
            // before saving, flatten first
            let params = {}

            _.each(state.form, function (group) {
                _.each(group, function (item) {
                    params[item.key] = item.value
                })
            })

            notify('info', 'menyimpan...', null, 'top-right');
            return sendRequest('general-setting', params, 'post', 
                // success
                (response) => {
                    clearNotify(), 
                    // update back
                    commit(SET_KEY_LIST, params)
                }, (error) => {
                clearNotify();
                notify('error', 'gagal menyimpan')
            })
        }
    },

    // call variable with custom display
    getters: {
        
    }
})
